import styles from './styles.module.scss';
import formatCurrency from '../../../../../../../Functions/formatCurrency';

const ServiceContainer = ({ service }) => {
  
    return (
      <div className={styles.serviceContainer}>
        <h2>Service Ordered</h2>
        <div className={styles.serviceItem}>
          <section>
            <h1>{service.service.name}</h1>
            <h2>{formatCurrency(service.orderDetails.total)}{service.service.costMode === 'Flat Rate' ? ' / Flat Rate' : ' / hr'}</h2>
          </section>
          <section>
            <h1>Scheduled</h1>
            <h2>{service.requestedDate} - {service.requestedTime}</h2>
          </section>
        </div>
      </div>
    );
  };
  
export default ServiceContainer;
